import React, { useState } from 'react';
import constants from '@/core/constants';
import { TEXT_CLASS } from '../../constants';
import { DataCourseExamMobile } from './styled';
import { Block } from '@/presentation/components';
import { ICourseExam, IMapCourseExam } from '../types';
import ReusableButton from '@/presentation/reusables/Button';
import { InfoContentModal } from '../ContentModal/InfoContentModal';

interface IExamsViewMobile {
  typeExam: string;
  dateExam: string;
  course: ICourseExam;
}

export const ExamViewMobile = ({
  course,
  typeExam,
  dateExam
}: IExamsViewMobile) => {
  const [openModal, setOpenModal] = useState(false);
  const {
    id,
    name,
    start,
    end,
    about,
    location,
    urlExamClass,
    modality,
    isDisabled
  } = course;
  const isPresential = modality === constants.CARD_TYPES.CURSO_PRESENCIAL;
  const [courseSelected, setCourseSelected] = useState<IMapCourseExam | null>(
    null
  );

  const handlerMapCourseData = () =>
    setCourseSelected({
      id,
      name,
      start,
      end,
      about,
      modality,
      typeExam,
      date: `${dateExam} de ${start} a ${end}`,
      urlExamClass,
      classroom: location?.classroom ?? TEXT_CLASS,
      pavilion: location?.pavilion ?? '',
      address: location?.address ?? '',
      floor: location?.floor ?? '',
      campus: location?.campus ?? '',
      sede: location?.sede ?? '',
      lat: location?.lat ?? 0,
      long: location?.long ?? 0,
      isDisabled
    });

  const handlerCloseModal = () => {
    setCourseSelected(null);
    setOpenModal(false);
  };

  const handlerAction = () => {
    if (isPresential) {
      handlerMapCourseData();
      setOpenModal(true);
      return;
    }
    document.open(urlExamClass ?? '', '_blank', 'noopener,noreferrer');
  };

  return (
    <Block
      key={course.id}
      data-testid="cmp-section-exam-rol"
      style={{
        backgroundColor: '#ECF4F9',
        borderRadius: '8px',
        padding: '12px 10px',
        marginBottom: '12px'
      }}
    >
      <DataCourseExamMobile isDisabled={isDisabled}>
        <div>
          <h1>Curso</h1>
          <span>{name}</span>
        </div>
        <div>
          <h1>Hora de inicio</h1>
          <span>{start}</span>
        </div>
        <div>
          <h1>Hora fin</h1>
          <span>{end}</span>
        </div>
        <div>
          <h1>Sobre</h1>
          <span>{about}</span>
        </div>
        <div>
          <h1>Ambiente</h1>
          <span>{isPresential ? location?.classroom : TEXT_CLASS}</span>
        </div>
        <div style={{ alignItems: 'center' }}>
          <h1>Acceso</h1>
          <span>
            <ReusableButton
              iconAppend={isPresential ? 'arrow-right' : 'external-link'}
              sizeIcon={24}
              disabled={isDisabled}
              onClick={() => handlerAction()}
              style={{
                width: isPresential ? '160px' : '150px',
                height: '40px',
                gap: '8px',
                padding: '0px 16px 0px 24px'
              }}
              outlined
            >
              {isPresential ? 'Ver ubicación' : 'Ir al examen'}
            </ReusableButton>
          </span>
        </div>
      </DataCourseExamMobile>
      {courseSelected && (
        <InfoContentModal
          isMobile
          show={openModal}
          onClose={() => handlerCloseModal()}
          dataCourseExam={courseSelected}
        />
      )}
    </Block>
  );
};
